import ObjectID from "bson-objectid";
const generateObjectId = () => new ObjectID().toString();
export default generateObjectId;
